"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var noopComponent = function () { return React.createElement(React.Fragment, null); };
var noop = function () { return; };
exports.DefaultUIActionsContext = {
    renderDatabasesActionMenu: noopComponent,
    renderTablesActionMenu: noopComponent,
    updateBreadcrumbs: noop,
    updateBreadcrumbHref: noop,
    setBrowserTitleWithPlaceEntityName: noop,
    setBrowserTitleWithPlaceNameFunction: noop,
    setBrowserTitleWithSpaceEntityNameAndTranslatedSubspaceName: noop,
    popToast: function () { return 0; },
    closeToast: noop,
};
exports.UIActionsContext = React.createContext(exports.DefaultUIActionsContext);
function consumeUIActionsContext(wrappedComponent) {
    return function UIActionsContextConsumerHOC(props) {
        return (React.createElement(exports.UIActionsContext.Consumer, null, function (uiActions) { return React.createElement(wrappedComponent, __assign({ uiActions: uiActions }, props)); }));
    };
}
exports.consumeUIActionsContext = consumeUIActionsContext;
//# sourceMappingURL=UIActionsContext.js.map